export const SZGK = 1;
export const BUSZ = 3;
export const TEHER = 2;
export const FELPOT = 18;
export const KONNYU_NEGYKEREKU = 16;
export const LASSU = 13;
export const MEZOGAZD = 5;
export const MOTOR = 7;
export const MUNKAGEP = 14;
export const POTKOCSI = 17;
export const SEGEDMOTOR = 15;
export const VONTATO = 6;
export const ROLLER = 19;
export const MIKROMOBILITAS = 20;
export const MIND = 1024;

export const fajtak = {
    [SZGK]: 'Személygépkocsi (M1)',
    [BUSZ]: 'Autóbusz (M2, M3)',
    [TEHER]: 'Teherautó (N1, N2, N3)',
    [FELPOT]: 'Félpótkocsi',
    [KONNYU_NEGYKEREKU]: 'Könnyű Négykerekű Segédmotoros Kerékpár (L6e)',
    [LASSU]: 'Lassú Jármű (Lj, T0)',
    [MEZOGAZD]: 'Mezőgazdasági Vontató (T1, T2, T3, T4, T5)',
    [MOTOR]: 'Motorkerékpár (L3e, L4e, L5e, L7e)',
    [MUNKAGEP]: 'Munkagép (S1, S2)',
    [MIKROMOBILITAS]: 'Egyéb mikromobilitási eszköz',
    [POTKOCSI]: 'Pótkocsi, Utánfutó (O1, O2, O3, O4, R1, R2, R3, R4)',
    [ROLLER]: 'Elektromos roller',
    [SEGEDMOTOR]: 'Segédmotor (L1e, L2e)',
    [VONTATO]: 'Vontató (N1, N2, N3)',
};

export const MINDEN_TIPUS = [
    SZGK,
    BUSZ,
    TEHER,
    FELPOT,
    KONNYU_NEGYKEREKU,
    LASSU,
    MEZOGAZD,
    MIKROMOBILITAS,
    MOTOR,
    MUNKAGEP,
    POTKOCSI,
    ROLLER,
    SEGEDMOTOR,
    VONTATO,
];

export function getIsMotor(category) {
    return category != null && [MOTOR, SEGEDMOTOR, KONNYU_NEGYKEREKU].includes(category);
}
